/** @format */

/**
 * https://github.com/dsg-tech/mtools-article-search/blob/main/src/main/java/com/dsg/mtools/article/search/model/Request.java
 */
export interface ArticleSearchV2Request {
  term?: string | null;
  chain: string;
  pageSize: number;
  pageNum: number;
  description?: string | null;
  title?: string | null;
  tags?: string | null;
  shouldProvidePlaceholderResults: boolean;
  filterByProperty?: string | null;
  filterByValue?: string | null;
}
